var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 2.66663C8.64784 2.66663 2.6665 8.64796 2.6665 16C2.6665 23.352 8.64784 29.3333 15.9998 29.3333C23.3518 29.3333 29.3332 23.352 29.3332 16C29.3332 8.64796 23.3518 2.66663 15.9998 2.66663ZM15.9998 26.6666C10.1185 26.6666 5.33317 21.8813 5.33317 16C5.33317 10.1186 10.1185 5.33329 15.9998 5.33329C21.8812 5.33329 26.6665 10.1186 26.6665 16C26.6665 21.8813 21.8812 26.6666 15.9998 26.6666Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 14.6667H17.3332V22.6667H14.6665V14.6667ZM14.6665 9.33337H17.3332V12H14.6665V9.33337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.84ec83046aa421b4b972cefee98b7037.svg";
export { ForwardRef as ReactComponent };